export default {
    // Roles disponibles para el selector (reutiliza GET /api/rol, mismo endpoint del módulo roles).
    roles: [],
    // Rol seleccionado en el selector (id). null = ningún rol seleccionado, checks deshabilitados.
    selectedRoleId: null,
    // Catálogo completo de indicadores del dashboard con su `check` para el rol seleccionado.
    // [{ section, section_label, name, label, check }]. Viene siempre completo del backend
    // (RoleDashboardPermissionService::CATALOG), con check=false si el rol nunca ha guardado nada.
    permissions: [],
    loading: false,
    saving: false
}



// WEBPACK FOOTER //
// ./src/modules/role-dashboard-permissions/state.js